import React, { Component, useState } from 'react';
import { Card, CardBody } from 'reactstrap'
import Postman from '../../utils/service'
import { Helmet } from 'react-helmet'
import './index.css'
import AppContext from '../../AppContext'
import { _location } from '../../common/const'
import { decodeforspace, encodeforspace, amountFormatter } from '../../utils/helper'

import { withRouter } from 'react-router-dom'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { getCompanybyName } from '../../actions/CompanyAction'
import profileIcon from '../../assets/img/employee/profile-icon.png';
import CompanyIcon from '../../assets/img/company_default.png';
import Logo from '../../assets/img/logo_login.png';
import { Link } from 'react-router-dom'
import Img from 'react-image'
import growjoIcon from '../../assets/img/logo.svg';
import SweetAlert from 'react-bootstrap-sweetalert';

import AdSense from 'react-adsense';
import Cookies from 'js-cookie';

const env = process.env.NODE_ENV || 'development';
const config = require('../../config.json')[env];
const main_server = config.main_server
Modal.setAppElement('#root')


class EmployeeDetail extends Component {
    constructor(props) {
        super(props)
        let name = props.data.data ? encodeforspace(props.data.data.first_name + '-' + props.data.data.last_name) + '-' + props.data.data.id : null;
        this.state = {
            data: props.data.data,
            name: '',
            empName: name,
            callingApi: false,
            isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
            showAlertRevealPhone: false,
        }
    }


    componentDidUpdate() {
        const name = decodeforspace(this.props.match.params.name)
        if (name == this.state.empName) {
            return false
        }
    }


    componentDidMount() {
        const name = decodeforspace(this.props.match.params.name)
        if (name == this.state.empName) {
            return false
        }
        if (this.state.callingApi) {
            return false
        }
        this.setState({ callingApi: true })
        this.getEmployeeData(name)

    }

    getEmployeeData(name) {
        Postman.getEmployeeByName(name)
            .then(res => {
                this.setState({ callingApi: false })
                if (res.data.data.success === false) {
                    if (res.data.data.errorCode == 404) {
                        this.props.history.push('/')
                    }
                } else {
                    this.setState({ data: res.data.data, empName: name })
                }

            }).catch((err,) => {
                this.setState({ callingApi: false })
            })
    }

    componentWillReceiveProps(nextprops, nextstate) {
        const name = decodeforspace(nextprops.match.params.name)

        if (name == this.state.empName) {
            return false
        }
        if (this.state.callingApi) {
            return false
        }
        this.setState({ callingApi: true })
        this.getEmployeeData(name)

    }

    getPhoneEmail = (id) => {
        if(!this.state.isLoggedIn) 
            return this.props.history.push('/join');
        Postman.getEmployeePhoneEmail(id)
            .then(res => {
                if (res.data.emp && res.data.emp.id) {
                    this.getEmployeeData(this.state.empName)
                    //this.setState({ empContacts: { ...this.state.empContacts, [id]: res.data.emp } })
                } else {
                    this.setState({ showAlertRevealPhone: true })
                }
            })
    }

    closeAlertRevealPhone = () => {
        this.setState({ showAlertRevealPhone: false })
    }

    render() {

        if (!this.state.data || !this.state.data.first_name) return null;
        const emp = this.state.data
        const name = emp.first_name + ' ' + emp.last_name
        const company = emp.GrowjoListFull
        const pastRoles = emp.EmployeeDetail

        let empEmail = (<a style={{fontSize: '20px'}} href="#" onClick={() => { navigator.clipboard.writeText(emp.email) }}>{emp.email} <i style={{ paddingLeft: '5px', cursor: 'pointer' }} className="fa fa-copy" ></i></a>);
        let empPhone = (<a style={{fontSize: '20px'}} href="#" onClick={() => { navigator.clipboard.writeText(emp.phone) }}>{emp.phone} <i style={{ paddingLeft: '5px', cursor: 'pointer' }} className="fa fa-copy"></i></a>);

        if (!this.state.isLoggedIn) {
            empEmail = (<Link style={{fontSize: '20px'}} to="/join">{emp.email}</Link>)
            empPhone = (<Link style={{fontSize: '20px'}} to="/join">{emp.phone}</Link>)
        }

        return (
            <div className="animated fadeIn mainView" style={{ height: '100%' }} data-bs-spy="scroll" data-bs-target=".navbar" data-bs-offset="50">
                <Helmet>

                    <title>{name + ' Email for ' + company.company_name} </title>
                    <meta name="description" content={`Free access to ` + name + `’s email at ` + company.company_name + ` (` + emp.email + `). Check out the free Growjo B2B dataset.`} />
                    <meta name="author" content="Growjo" />
                </Helmet>
                <SweetAlert
                    warning
                    // showCancel
                    title="Monthly Limit Reached!"
                    onConfirm={this.closeAlertRevealPhone}
                    show={this.state.showAlertRevealPhone}
                >
                    <Link to="/co-op"><strong>Get More Credits</strong></Link>
                </SweetAlert>
                <Card className='modifyCard' style={{ height: '100%' }}>
                    <CardBody className='tempCompany' style={{ height: '100%' }}>
                        <div className="row">
                                <div className="col-md-12">
                                    <div className="profile-info">
                                        <img width="80" src={profileIcon} alt="" />
                                        <div className="info">
                                            <div className="ch-1">
                                                <h1>{name + ' Email'}</h1>
                                                <p>{emp.title} . <Link to={`/company/${encodeforspace(company.company_name)}`}> {company.company_name}</Link></p>
                                            </div>
                                            <div className="ch-2 col-md-11">
                                                <div className="wpr">
                                                    <i className="fa fa-home" aria-hidden="true"></i>
                                                    <div>
                                                        <p>{company.city}, {company.state}</p>
                                                        <span>Location</span>
                                                    </div>
                                                </div>
                                                <div className="wpr">
                                                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                                    <div>
                                                        <p>{empEmail}</p>
                                                        <span>Primary Email</span>
                                                    </div>
                                                </div>
                                                <div className="wpr">
                                                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                                                    <div>
                                                        <p>
                                                            <a href={emp.linkedin} target="_blank">{emp.linkedin}</a>

                                                        </p>
                                                        <span>LinkedIn</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                               

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="contact-info">
                                            <div className="head">
                                                <h2>How to contact {name}</h2>
                                                {!this.state.isLoggedIn && <Link to="/join" className="btn">Join and see {emp.first_name}'s contact info for free!</Link>}
                                            </div>
                                            <div className="info">
                                                <div className="wpr">
                                                    <div>
                                                        <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                                        <p>Email</p>
                                                    </div>
                                                    <div>
                                                        {empEmail}
                                                        {this.state.isLoggedIn && !emp.unlocked_person && <button style={{ borderRadius: "7px" }} className='btn btn-primary' onClick={() => this.getPhoneEmail(emp.id)}>Reveal Email/Phone</button>}
                                                    </div>
                                                </div>

                                                {emp.phone && <div className="wpr">
                                                    <div>
                                                        <i className="fa fa-mobile" aria-hidden="true"></i>
                                                        <p>Phone</p>
                                                    </div>
                                                    <div>
                                                        {empPhone}
                                                    </div>
                                                </div>}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                    <AdSense.Google
                                        client='ca-pub-1304487994033637'
                                        slot='4128680171'
                                        style={{ display: "block" }}
                                        responsive='true'
                                        format="auto"
                                        fullwidthresponsive="true"

                                        />
                                    </div>
                                </div>

                                {/* <div className="grow-sec">
                                    <div className="wpr">

                                        <img src={growjoIcon} width="65" alt="" />
                                        <div>
                                            <h1>GROWJO</h1>
                                            <p>The Free Company & People Database</p>
                                        </div>
                                    </div>
                                    {!this.state.isLoggedIn && <div className="btn-wrapper">
                                        <Link to={`/join`} className="btn">Join for Free!</Link>
                                    </div>}
                                </div> */}


                                <div className="associated-companies" style={{paddingTop:"40px"}}>
                                    <h2>Current Roles</h2>
                                    <div className="item">
                                        <div className="profile">
                                            <div>
                                                <a href={`/company/${encodeforspace(company.company_name)}`} target="_blank" style={{ textDecoration: 'none' }}><Img style={{ maxWidth: '50px' }} src={[`//logo.clearbit.com/${company.url}?size=100`, '/static/img/company_default.png']} /></a>

                                            </div>
                                            <div>
                                                <div className="heading">
                                                    <h4>
                                                        <Link to={`/company/${encodeforspace(company.company_name)}`}> {company.company_name}</Link>
                                                    </h4>

                                                    {/* <h3>Get all of our best features!</h3> */}
                                                </div>
                                                <div style={{ paddingTop: '0px', display: 'flex', gap: '10px', alignItems: 'center' }}>

                                                    <h5 style={{ margin: '0px' }}>
                                                        Employees:
                                                    </h5>
                                                    <span>
                                                        {company.current_employees}
                                                    </span>
                                                </div>

                                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

                                                    <h5 style={{ margin: '0px' }}>
                                                        Revenue:
                                                    </h5>
                                                    <span>
                                                        ${amountFormatter(company.estimated_revenues, 1)}
                                                    </span>
                                                </div>
                                                <div>

                                                    <h5>
                                                        About
                                                    </h5>
                                                    <span>
                                                        {company.bio}
                                                    </span>
                                                </div>


                                                <div>
                                                    <h5>
                                                        {company.company_name + ' Address'}
                                                    </h5>
                                                    <span>
                                                        {company.address1} <br />
                                                        {company.city + ', ' + company.state}<br />
                                                        {company.country}
                                                    </span>
                                                </div>
                                                <div>
                                                    <h5>
                                                        {company.company_name + ' Email'}
                                                    </h5>
                                                    <a className="email">{company.email_1}</a>
                                                    <a className="email">{company.email_2}</a>
                                                </div>
                                                {company.phone && <div>
                                                    <h5>
                                                        {company.company_name + ' Phone Numbers'}
                                                    </h5>
                                                    <a > {company.phone}</a>

                                                    {!this.state.isLoggedIn && <div>
                                                        <Link to={`/join`} className="cbtn">Join and see {emp.first_name}'s phone number for free!</Link>
                                                    </div>}
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {pastRoles && <div className="associated-companies" style={{ paddingTop: '20px' }}>
                                    <h2>Past Companies</h2>
                                    {pastRoles.company_name_1 && <div className="item">
                                        <div className="profile">
                                            <div>
                                                <Img style={{ maxWidth: '50px' }} src={CompanyIcon} />
                                            </div>
                                            <div>
                                                <div className="heading" style={{ marginTop: '12px' }}>
                                                    <h6>
                                                        {pastRoles.company_name_1}
                                                        <span className="" style={{ fontWeight: "normal", paddingLeft: "10px" }}>
                                                            {pastRoles.title_1}
                                                        </span>
                                                    </h6>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    }

                                    {pastRoles.company_name_2 && <div className="item">
                                        <div className="profile">
                                            <div>
                                                <Img style={{ maxWidth: '50px' }} src={CompanyIcon} />
                                            </div>
                                            <div>
                                                <div className="heading" style={{ marginTop: '12px' }}>
                                                    <h6>
                                                        {pastRoles.company_name_2}
                                                        <span className="" style={{ fontWeight: "normal", paddingLeft: "10px" }}>
                                                            {pastRoles.title_2}
                                                        </span>
                                                    </h6>
                                                </div>
                                            </div>

                                        </div>
                                    </div>}
                                    {pastRoles.company_name_3 && <div className="item">
                                        <div className="profile">
                                            <div>
                                                <Img style={{ maxWidth: '50px' }} src={CompanyIcon} />
                                            </div>
                                            <div>
                                                <div className="heading" style={{ marginTop: '12px' }}>
                                                    <h6>
                                                        {pastRoles.company_name_3}
                                                        <span className="" style={{ fontWeight: "normal", paddingLeft: "10px" }}>
                                                            {pastRoles.title_3}
                                                        </span>
                                                    </h6>
                                                </div>
                                            </div>

                                        </div>
                                    </div>}
                                </div>

                                }



                            </div>
                            {/* <div class="col-lg-3 d-none d-md-block profile-right">
                                <div class="info">
                                    <div class="content-head">
                                        <Img src={Logo} alt="logo" />
                                        <Link to={`/`} >www.growjo.com</Link>
                                    </div>
                                    <div class="content-body">
                                        <h1>#1 Startup Dataset</h1>
                                        <p>Growth rates, revenue data, direct competitors and contact details.</p>
                                        <button class="btn">Get More Info</button>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                    </CardBody>
                </Card>
            </div >

        );
    }
}

//CompanyDetail.contextType = AppContext;
const mapStateToProps = state => ({
    user: state.auth.user,
})
const WithRouterEmployeeDetail = withRouter(connect(mapStateToProps, { getCompanybyName })(EmployeeDetail))
class EmployeeDetailWrapper extends React.Component {
    render() {
        return (
            <WithRouterEmployeeDetail data={this.context || []} {...this.props} />
        )
    }
}
EmployeeDetailWrapper.contextType = AppContext;
export default EmployeeDetailWrapper;



// WEBPACK FOOTER //
// ./client/src/views/EmployeeDetail/index.js